<template>
  <lf-card class="mb-8 max-w-(--breakpoint-md)">
    <loader :is-loading="isSubmitting" />
    <form class="flex flex-col divide-y py-8" @submit.prevent="submit">
      <div class="pb-5">
        <lf-switch
          v-model="initialValues.data.has_custom_emails_enabled"
          name="data.has_custom_emails_enabled"
          class="space-y-2"
        >
          <lf-h3>
            {{ $t("ORGANIZATION.ENABLE_EMAIL_TEMPLATES_BUILDER") }}
          </lf-h3>
          <span>
            {{ $t("ORGANIZATION.ENABLE_EMAIL_TEMPLATES_SUBTITLE") }}
          </span>
        </lf-switch>
      </div>
      <div class="flex min-w-full items-center justify-end pt-5 pr-5">
        <primary-button
          type="submit"
          :disabled="isSubmitting"
          data-cy="email-templates-submit"
        >
          {{ $t("ORGANIZATION.API_CONFIG.SAVE_CHANGES") }}
        </primary-button>
      </div>
    </form>
  </lf-card>
</template>

<script setup lang="ts">
import { reactive } from "vue";

import { useForm } from "vee-validate";

import { dispatchAction } from "@/helpers/vee-validate";
import { useClients } from "@/hooks/clients";

const { activeClient } = useClients();

const initialValues = reactive({
  data: {
    has_custom_emails_enabled: !!activeClient.value?.has_custom_emails_enabled,
  },
});

const { handleSubmit, isSubmitting } = useForm({
  initialValues,
});

const submit = handleSubmit(async (values, actions) => {
  await dispatchAction(values, actions, "clients/updateClient");
});
</script>
